// store/ws.js
import { getToken } from '@/utils/auth'

const ws = {
  state: {
    ws: null,
    connected: false,
    messages: [],
    heartbeatTimer: null,
    reconnectTimer: null,
    lockReconnect: false,
  },
  mutations: {
    SET_WS(state, ws) { state.ws = ws },
    SET_CONNECTED(state, s) { state.connected = s },
    ADD_MESSAGE(state, msg) {
      // 如果没有 id，直接插入
      if (!msg.id) {
        state.messages.push(msg)
        return
      }

      // 查重
      const exists = state.messages.some(m => m.id === msg.id)

      if (!exists) {
        state.messages.push(msg)
      } else {
        console.log("⚠️ 重复消息已丢弃:", msg.id)
      }
    },
    SET_HEARTBEAT(state, t) { state.heartbeatTimer = t },
    SET_RECONNECT(state, t) { state.reconnectTimer = t },
    SET_LOCK_RECONNECT(state, l) { state.lockReconnect = l },
  },
  actions: {
    initWebSocket({ state, commit, dispatch }) {
      return new Promise((resolve, reject) => {
        if (state.ws && state.connected) return resolve(state.ws)
        if (state.lockReconnect) return resolve(state.ws)

        commit('SET_LOCK_RECONNECT', true)
        const token = getToken()
        // const ws = new WebSocket(`wss://admin.u.arctofit.com:4000/ws?token=${token}`)
        const ws = new WebSocket(`ws://localhost:8745/ws?token=${token}`)
        ws.onopen = () => {
          console.log('✅ WS OPEN')
          commit('SET_CONNECTED', true)
          commit('SET_LOCK_RECONNECT', false)
          dispatch('startHeartbeat')
          resolve(ws)
        }

        ws.onmessage = e => {
          const msg = JSON.parse(e.data)
            // 跳过心跳包
        if (msg.msgType === 7){
           console.log('收到服务端的心跳消息')
           return
        } 
        
          console.log('收到消息已经格式化:', msg)
          commit('ADD_MESSAGE', msg, { root: true })
        }
        ws.onerror = err => { commit('SET_LOCK_RECONNECT', false); ws.close(); reject(err) }
        ws.onclose = () => {
          console.log('✅ WS onclose')
          commit('SET_CONNECTED', false); commit('SET_LOCK_RECONNECT', false); dispatch('stopHeartbeat'); dispatch('reconnect')
        }

        commit('SET_WS', ws)
      })
    },

    sendMessage({ state }, messageBody) {
      if (state.ws && state.connected) state.ws.send(messageBody)
    },
    
    startHeartbeat({ state, commit }) {
      if (state.heartbeatTimer) clearInterval(state.heartbeatTimer)
      const timer = setInterval(() => {
        if (state.ws && state.connected) state.ws.send(JSON.stringify({ msgType: 7 }))
      }, 3000)
      commit('SET_HEARTBEAT', timer)
    },

    stopHeartbeat({ state, commit }) {
      if (state.heartbeatTimer) clearInterval(state.heartbeatTimer)
      commit('SET_HEARTBEAT', null)
    },
    reconnect({ state, commit, dispatch }) {
      if (state.lockReconnect) return
      if (state.reconnectTimer) clearTimeout(state.reconnectTimer)
      commit('SET_LOCK_RECONNECT', true)
      const timer = setTimeout(() => dispatch('initWebSocket'), 3000)
      commit('SET_RECONNECT', timer)
    },
    closeWebSocket({ state, commit, dispatch }) {
      dispatch('stopHeartbeat')
      if (state.ws) state.ws.close()
      commit('SET_WS', null)
      commit('SET_CONNECTED', false)
    },
  }
}

export default ws


// WEBPACK FOOTER //
// ./src/store/ws.js